var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFichas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_fichas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_invoice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8367",
    "data-name": "Group 8367",
    transform: "translate(4.219 1.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8366",
    "data-name": "Group 8366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20019",
    "data-name": "Path 20019",
    d: "M15.815,88.263c-.4,10.469-15.406,10.469-15.807,0V84.591H1.224v3.672c.316,8.852,13.059,8.852,13.375,0-.085-1.788.316-5.9-.535-7.5l.9-.9c1.265,2.006.754,6.128.851,8.4Z",
    transform: "translate(-0.008 -75.526)",
    fill: "currentColor",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20020",
    "data-name": "Path 20020",
    d: "M7.9,1.186a6.716,6.716,0,0,1,5.544,2.942l.863-.863C9.971-2.887.012.225,0,7.849H1.216A6.7,6.7,0,0,1,7.9,1.186Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20021",
    "data-name": "Path 20021",
    d: "M69.332,181.023H68.1a4.256,4.256,0,0,0,8.463-.608V177.3H75.351v3.113a3.044,3.044,0,0,1-6.019.608Z",
    transform: "translate(-64.407 -167.678)",
    fill: "currentColor",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20022",
    "data-name": "Path 20022",
    d: "M75.72,71.563a4.256,4.256,0,0,0-8.511,0v4.256h1.216V71.563a3.06,3.06,0,1,1,6.08.535H75.72v-.535Z",
    transform: "translate(-63.561 -63.689)",
    fill: "currentColor",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20023",
    "data-name": "Path 20023",
    d: "M135.628,139.582v-4.864a.608.608,0,0,0-1.216,0v4.864a.608.608,0,0,0,1.216,0",
    transform: "translate(-127.116 -126.845)",
    fill: "currentColor",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFichas);
export default __webpack_public_path__ + "static/media/ico_fichas.cc386378.svg";
export { ForwardRef as ReactComponent };